module.exports = __webpack_public_path__ + "static/shelter-2f775bd0a11d1efe97c3169b27501e78.jpg";